import Vue from 'vue';
import CKEditor from '@ckeditor/ckeditor5-vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';
import router from './router';
import store from './store/index';

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => !record.meta.service)) {
    try{
      await store.dispatch('user/getUser');
      if (store.state.user) {
        console.log('store.state.user: ', store.state.user);
        next();
      } else {
        next({ name: 'auth' });
      }
    }
    catch(e) {
      next({ name: 'auth' });
    }
  }
  next();
});

Vue.config.productionTip = false;

Vue.use(CKEditor);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCJA0XhjnsRfGXU1zR3CwKwnuFA5slbAlc',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },
});

const VueInputMask = require('vue-inputmask').default;

Vue.use(VueInputMask);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
